/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';

import { BuilderSharedModule } from '@gh/builder-shared';

import { BuilderSetupManagementRoutingModule } from './builder-setup-routing.module';
@NgModule({
  imports: [
    BuilderSharedModule.forChild(),
    BuilderSetupManagementRoutingModule,
  ],
})
export class BuilderSetupManagementModule {
}
